import {DialogContent, HStack, Input, Stack, Text} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {DialogActionTrigger, DialogBody, DialogFooter, DialogHeader, DialogRoot, DialogTitle} from "./ui/dialog";
import {Field} from "./ui/field";
import {Button} from "./ui/button";
import {addOrganization} from "../api/organization";

// @ts-ignore
const AddOrganizationModel = ({isCreateModelOpened, setIsCreateModelOpened, fetchData}) => {
    const [name, setName] = useState("");
    const [inn, setInn] = useState("");
    const [isAddButtonDisable, setIsAddButtonDisable] = useState(true);
    const [isAddButtonLoading, setIsAddButtonLoading] = useState(false);
    const [isAddError, setIsAddError] = useState(false);

    useEffect(() => {
        setIsAddButtonDisable(!(name != "" && /^(\d{10}|\d{12})$/.test(inn)));
    }, [name, inn])

    const addOrganizationHandler = async () => {
        setIsAddButtonLoading(true)
        setIsAddError(false)
        try {
            await addOrganization(name, inn)
            setIsCreateModelOpened(false)
            await fetchData()
        } catch (e) {
            // @ts-ignore
            if (e.response.data.message.includes("already exists")) {
                setIsAddError(true)
            }
        }

        setIsAddButtonLoading(false)
    }

    useEffect(() => {
        setIsAddButtonLoading(false)
        setIsAddButtonDisable(true)
        setIsAddError(false)
        setName("")
        setInn("")
    }, [isCreateModelOpened]);

    return (
        <HStack position="absolute" width="100%" style={{ marginTop: '-100px'}}>
            <DialogRoot open={isCreateModelOpened}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Добавление компании</DialogTitle>
                    </DialogHeader>
                    <DialogBody>
                        <form>
                            <Stack width="full">
                                <Field label="Наименование организации" required color="#88898A">
                                    <Input value={name} onChange={e => setName(e.target.value)}
                                           placeholder="Наименование организации" color="#2F4F4F"/>
                                </Field>
                                <Field label="ИНН (10  или 12 цифр)" required color="#88898A">
                                    <Input value={inn} onChange={e => setInn(e.target.value)} placeholder="ИНН"
                                           color="#2F4F4F"/>
                                </Field>
                                {isAddError &&
                                    <Text textStyle="sm" color="red">Организация с таким ИНН уже есть в базе</Text>}
                            </Stack>
                        </form>
                    </DialogBody>
                    <DialogFooter>
                        <DialogActionTrigger asChild>
                            <Button variant="outline" onClick={() => setIsCreateModelOpened(false)}
                                    disabled={isAddButtonLoading}>Отмена</Button>
                        </DialogActionTrigger>
                        <Button disabled={isAddButtonDisable} loading={isAddButtonLoading}
                                onClick={addOrganizationHandler}>Добавить</Button>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </HStack>
    )
}

export default AddOrganizationModel